import React from "react"
import DatePicker from 'react-datepicker'
import { FormGroup, ControlLabel, FormControl, Button, Checkbox, Row, Col } from 'react-bootstrap'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { makeOptions } from './helper'
import Moment from 'moment'

class userProfile extends React.Component {
  constructor(props) {
    super(props);
    const extras = props.data.extras || {}
    const normalizedDob = extras.date_of_birth ? Moment.utc(extras.date_of_birth) : null
    this.state = {
      id: props.data._id,
      first_name: props.data.first_name,
      last_name: props.data.last_name,
      email: props.data.email,
      phone: extras.phone,
      postal_code: extras.postal_code,
      address: extras.address,
      social: extras.social,
      city: extras.city,
      province: extras.province,
      gender: extras.gender,
      marketing_opt_out: props.data.marketing_opt_out,
      parent_notes: extras.parent_notes,
      date_of_birth: normalizedDob,
      udfs: props.data.udfs ? props.data.udfs: null,
      org_id: props.organization_id ? props.organization_id : null,
      orgUDFs: props.orgUDFs ? props.orgUDFs : null,
      updated: props.data.updated ? props.data.updated : null,
      athleteSpinner: props.data.spinner ? props.data.spinner: false,
      initial_snapshot: this.buildSnapshot({
        first_name: props.data.first_name,
        last_name: props.data.last_name,
        email: props.data.email,
        phone: extras.phone,
        postal_code: extras.postal_code,
        address: extras.address,
        social: extras.social,
        city: extras.city,
        province: extras.province,
        gender: extras.gender,
        marketing_opt_out: props.data.marketing_opt_out,
        parent_notes: extras.parent_notes,
        date_of_birth: normalizedDob,
        udfs: props.data.udfs ? props.data.udfs : null,
      })
    };
  }

  buildSnapshot = (overrides = this.state) => ({
    first_name: overrides.first_name || '',
    last_name: overrides.last_name || '',
    email: overrides.email || '',
    phone: overrides.phone || '',
    postal_code: overrides.postal_code || '',
    address: overrides.address || '',
    social: overrides.social || '',
    city: overrides.city || '',
    province: overrides.province || '',
    gender: overrides.gender || '',
    marketing_opt_out: !!overrides.marketing_opt_out,
    parent_notes: overrides.parent_notes || '',
    date_of_birth: overrides.date_of_birth ? Moment(overrides.date_of_birth).toISOString() : '',
    udfs: overrides.udfs ? JSON.stringify(overrides.udfs) : ''
  })

  isDirty = () => {
    return JSON.stringify(this.buildSnapshot()) !== JSON.stringify(this.state.initial_snapshot || {})
  }

  handleChange = (field, e) => {
    var val = e.target ? e.target.value : e
    this.setState({[field]: val, updated: false})
  }

  handleUDFChanges = (udf, e, number) => {
    var changeUDFs = this.state.udfs.slice()
    var val = e.target ? e.target.value : e
    var udfChange = changeUDFs.find(prevUDF => {return prevUDF.key === udf && JSON.stringify(this.state.org_id) === JSON.stringify(prevUDF.organization_id)})
    var index = changeUDFs.indexOf(udfChange)
    if (udfChange) {
      udfChange.value = number ? +val : val
      changeUDFs[index] = udfChange
      this.setState({
        udfs: changeUDFs,
        updated: false
      })
    }
  }

  handleUpdateSubmit = () => {
    this.props.data.spinner = true
    var formFields = this.getFormFields()
    this.props.patchUpdateMethod(formFields, this.state.id, 'athlete_spinner')
  }
  
  getFormFields() {
    console.log('getFormFields', this.state)
    return {
      "first_name": this.state.first_name,
      "last_name": this.state.last_name,
      "email": this.state.email,
      "marketing_opt_out": this.state.marketing_opt_out,
      "udfs": this.state.udfs,
      "extras": {
        "phone": this.state.phone,
        "date_of_birth": this.state.date_of_birth ,
        "gender": this.state.gender,
        "address": this.state.address,
        "postal_code": this.state.postal_code,
        "city": this.state.city,
        "province": this.state.province,
        "social": this.state.social,
        "parent_notes": this.state.parent_notes,
      },
    }
  }

  render() {
    const { orgUDFs, udfs, org_id } = this.state
    var genderOptions = [];
    var gender_type_arr = ["female", "male"];
    if (!this.state.gender) {
        genderOptions.push(<option value="" selected disabled>---</option>)
    }
    gender_type_arr.forEach((type) => {
      type == this.state.gender ? genderOptions.push(<option value={type} selected>{type}</option>) : genderOptions.push(<option value={type}>{type}</option>)
    })
    return (
      <div className="parent-family-card parent-family-card-summary athlete-profile-card">
        <div className="parent-family-card-header">
          <div>
            <div className="parent-family-name">{this.state.first_name} {this.state.last_name}</div>
            <div className="parent-family-meta">{this.state.email || 'No email on file'}</div>
          </div>
          <div className="parent-family-badge">Athlete</div>
        </div>

        <form>
          <Row className="margin-2">
              <Row>
              <Col sm={4}>
                <FormGroup>
                  <ControlLabel>First Name</ControlLabel>
                  <FormControl className="opaque-grey" name="first_name" type="text" id="first_name" value={this.state.first_name} onChange={(e) => this.handleChange('first_name', e)} />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <ControlLabel>Last Name</ControlLabel>
                  <FormControl className="opaque-grey" name="last_name" type="text" id="last_name" value={this.state.last_name} onChange={(e) => this.handleChange('last_name', e)} />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <ControlLabel>Gender</ControlLabel>
                  <FormControl className="opaque-grey" name="gender" id="gender" componentClass="select" onChange={(e) => this.handleChange('gender', e)}>
                    {genderOptions}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <ControlLabel>Address</ControlLabel>
                  <FormControl className="opaque-grey" name="address" type="text" id="address" value={this.state.address} onChange={(e) => this.handleChange('address', e)} />
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <ControlLabel>City</ControlLabel>
                  <FormControl className="opaque-grey" name="city" type="text" id="city" value={this.state.city} onChange={(e) => this.handleChange('city', e)}/>
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <ControlLabel>Province</ControlLabel>
                  <FormControl className="opaque-grey" name="province" type="text" id="province" value={this.state.province} onChange={(e) => this.handleChange('province', e)}/>
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <ControlLabel>Postal Code</ControlLabel>
                  <FormControl className="opaque-grey" name="postal_code" type="text" id="postal_code" value={this.state.postal_code} onChange={(e) => this.handleChange('postal_code', e)}/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <FormGroup>
                  <ControlLabel>Email</ControlLabel>
                  <FormControl className="opaque-grey" name="email" type="text" id="email" value={this.state.email} onChange={(e) => this.handleChange('email', e)} />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <ControlLabel>Phone</ControlLabel>
                  <FormControl className="opaque-grey" name="phone" type="text" id="phone" value={this.state.phone} onChange={(e) => this.handleChange('phone', e)}/>
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <ControlLabel>Date of Birth</ControlLabel>
                  <DatePicker className="opaque-grey form-control" name="date_of_birth" id={"date_of_birth"} utcOffset={0} selected={this.state.date_of_birth} placeholderText="MM/DD/YYYY" showYearDropdown onChange={(e) => this.setState({date_of_birth: e})}/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
            {
              udfs && orgUDFs && 
              udfs.map((udf, index) => {
                var orgUDF = orgUDFs.find(orgudf => { return orgudf.key === udf.key && JSON.stringify(org_id) === JSON.stringify(udf.organization_id)})
                if (orgUDF) {
                  return (
                    <Col key={index} sm={4}>
                      <FormGroup>
                          <ControlLabel>{orgUDF.label}</ControlLabel>
                          {
                            orgUDF.type.format === 'list' ?
                              <FormControl  className="opaque-grey" name={orgUDF.label} componentClass="select" id={orgUDF.label} defaultValue={udf.value} onChange={(e) => this.handleUDFChanges(udf.key, e)}>
                              {makeOptions(orgUDF)}
                            </FormControl>
                            :
                            orgUDF.type.format === 'number' ?
                            <FormControl className="opaque-grey" name={orgUDF.label} id={orgUDF.label} placeholder="" type="number" min="0" defaultValue={udf.value} onChange={(e) => this.handleUDFChanges(udf.key, e, 'number')}/>
                            :
                            <FormControl className="opaque-grey" name={orgUDF.label} type="text" id={orgUDF.label} placeholder="" defaultValue={udf.value} onChange={(e) => this.handleUDFChanges(udf.key, e)}/>
                          }  
                      </FormGroup>
                    </Col>
                  )
                }
              })
            }
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <ControlLabel>Parent Notes</ControlLabel>
                  <FormControl className="opaque-grey" name="parent_notes" componentClass="textarea" id="parent_notes" value={this.state.parent_notes} onChange={(e) => this.handleChange('parent_notes', e)}/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={3} className="pull-right">
                <FormGroup>
                  <Checkbox checked={!this.state.marketing_opt_out} name="marketing_opt_out" id="marketing_opt_out" onClick={() => this.setState({ marketing_opt_out: !this.state.marketing_opt_out })}>
                    Receive marketing emails
                  </Checkbox>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={3} className="pull-right">
                {
                  this.state.athleteSpinner ? <div className="enrolment-loader"></div> 
                  :
                    this.state.updated ?
                    <div className="email-sent pull-right">
                      <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                      <p className="email-text">Profile Updated</p>
                    </div>
                  :
                  <Button className="orange-fill" disabled={!this.isDirty()} onClick={this.handleUpdateSubmit}>
                    Update
                  </Button>
                }

              </Col><br/><br/><br/>
            </Row>
            {
              this.props.archiveFromParentPortal ? (
                <Row>
                  <Col sm={3} className="pull-right">
                    <Button
                      className="searchbtn"
                      style={{ marginBottom: '1rem' }}
                      onClick={() => this.props.archiveFromParentPortal(this.state.id)}
                    >
                      Remove from My Family
                    </Button>
                  </Col>
                </Row>
              ) : null
            }
          </Row>
        </form>
      </div>
    );
  }
}

export default userProfile;
